import { differenceInDays } from 'date-fns'

class DataLayerSession {

  constructor() {
    this.storage = window.localStorage
  }


  getVisitData() {

    if (this.storage) {

      const lastVisitDate = this.getLastVisitDate()
      let daysSinceLastVisit = 0

      if (lastVisitDate) {
        daysSinceLastVisit = differenceInDays(new Date(), lastVisitDate)
      }

      const numVisits = this.getNumVisits()

      return {
        numVisits,
        hasLoggedInBefore: this.hasLoggedInBefore(),
        daysSinceLastVisit,
        lastVisitDate,
      }
    }
  }

  getNumVisits() {
    const numVisits = this?.storage?.getItem('numVisits')
    return numVisits ? parseInt(numVisits) : 0
  }

  incrementNumVisits() {
    const numVisits = this.getNumVisits()
    this?.storage?.setItem('numVisits', (numVisits + 1).toString())
  }

  getLastVisitDate() {
    const lastVisitDate = this?.storage?.getItem('lastVisitDate')
    return lastVisitDate ? new Date(lastVisitDate) : undefined
  }

  hasLoggedInBefore() {
    return this?.storage?.getItem('lastLoginDate') ? true : false
  }

}

export const dataLayerSession = new DataLayerSession()

